<div>
  <div class="ai-cards-header">
    <h2 class="ai-title">{{ "AI.JOB_MONITORING.TITLE" | translate }}</h2>
    <h3 class="ai-subtitle">
      {{ "AI.SEGMENTATION_LIST.DESCRIPTION" | translate }}
    </h3>
  </div>
  <div *ngIf="stats" class="ai-cards-row w-100">
    <div class="job-monitoring-card">
      <lib-card
        [label]="'AI.JOB_MONITORING.UPLOADED_ENTRIES'"
        [value]="stats.uploadedEntriesSum"
        [showDropdown]="false"
        [showToggle]="false"
      >
      </lib-card>
    </div>
    <div class="job-monitoring-card">
      <lib-card
        [label]="'AI.JOB_MONITORING.PROCESSED_ENTRIES'"
        [value]="stats.processedEntriesSum"
        [showDropdown]="false"
        [showToggle]="false"
      >
      </lib-card>
    </div>
    <div class="job-monitoring-card">
      <lib-card
        [label]="'AI.JOB_MONITORING.COMPLETED_ENTRIES'"
        [value]="stats.completedEntriesSum"
        [showDropdown]="false"
        [showToggle]="false"
      >
      </lib-card>
    </div>
  </div>
  <div class="table-wrapper job-monitoring-table">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="th-checkbox"><input type="checkbox" /></th>
            <th>{{ "AI.JOB_MONITORING.UPLOAD_ID" | translate }}</th>
            <th>{{ "AI.JOB_MONITORING.UPLOAD_DATE" | translate }}</th>
            <th>
              {{ "AI.JOB_MONITORING.UPLOADED_ENTITIES_NUMBER" | translate }}
            </th>
            <th>
              {{ "AI.JOB_MONITORING.NUMBER_OF_PROCESSED_ENTRIES" | translate }}
            </th>
            <th>{{ "AI.JOB_MONITORING.STATUS" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let history of histories">
            <td><input type="checkbox" /></td>
            <td>{{ history.guid }}</td>
            <td>{{ history.date | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            <td class="no-wrap-cell">
              <div class="progress-wrapper">
                <div class="progress-container">
                  <div
                    class="progress-bar"
                    [style.width]="history.uploadProgressBarWidth + '%'"
                  ></div>
                </div>
                <span class="progress-text"
                  >{{ history.uploadedCount }}/{{ history.maxCount }}</span
                >
              </div>
            </td>
            <td class="no-wrap-cell">
              <div class="progress-wrapper">
                <div class="progress-container">
                  <div
                    class="progress-bar"
                    [style.width]="history.processProgressBarWidth + '%'"
                  ></div>
                </div>
                <span class="progress-text"
                  >{{ history.processedCount }}/{{
                    history.maxProcessedCount
                  }}</span
                >
              </div>
            </td>
            <td>
              <span class="status" [ngClass]="getStatusColorClass(history)">
                {{ history.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination">
        <lib-asset-list-pagination
          [pageFromList]="currentPage"
          (pageChanged)="onPageChange($event)"
          [totalItems]="count"
        ></lib-asset-list-pagination>
      </div>
    </div>
  </div>
</div>
